import styled, { css } from 'styled-components'

export interface MainContentProps {
  $filterCollapsed?: boolean
}

export interface MapWrapperProps {
  $hidden?: boolean
}

export interface ListViewContainerProps {
  $active?: boolean
}

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: ${({ theme }) => theme.colors.background.secondary};
  color: ${({ theme }) => theme.colors.text.primary};
  line-height: 1.5;
  font-size: 14px;
  font-family: ${({ theme }) => theme.typography.fontFamily.sans};
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow: hidden;
`

export const AppContainer = styled.div`
  display: flex;
  height: calc(100vh - 56px);
  position: relative;
`

export const MainContent = styled.div.withConfig({
  shouldForwardProp: (prop) => !prop.startsWith('$'),
})<MainContentProps>`
  flex: 1;
  position: relative;
  display: flex;

  @media (min-width: 769px) {
    margin-left: 0;
  }
`

export const ViewSwitcherContainer = styled.div`
  position: absolute;
  top: 16px;
  left: 40px;
  z-index: 10;

  @media (max-width: 768px) {
    top: 12px;
    left: 4px;
    max-width: 40%;
  }
`

export const MapSearchContainer = styled.div`
  position: absolute;
  top: 16px;
  left: 16px;
  right: 16px;
  max-width: 400px;
  margin: 0 auto;
  z-index: 10;

  @media (max-width: 768px) {
    top: 12px;
    left: auto;
    right: 12px;
    width: 56%;
    max-width: none;
  }
`

export const MapWrapper = styled.div.withConfig({
  shouldForwardProp: (prop) => !prop.startsWith('$'),
})<MapWrapperProps>`
  flex: 1;
  position: relative;
  display: flex;

  ${({ $hidden }) =>
    $hidden &&
    css`
      display: none;
    `}
`

export const MapContainer = styled.div`
  flex: 1;
  position: relative;
  background: ${({ theme }) => theme.colors.background.tertiary};
`

export const ListViewContainer = styled.div.withConfig({
  shouldForwardProp: (prop) => !prop.startsWith('$'),
})<ListViewContainerProps>`
  display: none;
  flex: 1;
  background: ${({ theme }) => theme.colors.background.secondary};
  overflow-y: auto;
  position: relative;

  ${({ $active }) =>
    $active &&
    css`
      display: block;
    `}
`

export const ListViewContent = styled.div`
  height: 100%;
  padding: 16px;
  margin: 0 auto;
  margin-top: 50px;
  margin-left: 24px;

  @media (max-width: 768px) {
    padding: 16px;
    margin-left: auto;
  }
`

export const ListPlaceholder = styled.div`
  height: 100%;
  background: ${({ theme }) => theme.colors.background.primary};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  border: 1px solid ${({ theme }) => theme.colors.border.default};
  padding: 60px;
  text-align: center;
  color: ${({ theme }) => theme.colors.text.secondary};

  .icon {
    width: 48px;
    height: 48px;
    margin-bottom: 16px;
    color: ${({ theme }) => theme.colors.text.tertiary};
    stroke-width: 1.5;
  }

  h3 {
    font-size: 18px;
    margin-bottom: 8px;
    color: ${({ theme }) => theme.colors.text.primary};
  }

  p {
    margin: 0;
  }
`

export const MobileOverlay = styled.div`
  display: none;
  position: fixed;
  top: 64px;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 250;
  opacity: 0;
  transition: opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &.active {
    display: block;
    opacity: 1;
  }

  @media (max-width: 768px) {
    display: block;

    &.active {
      opacity: 1;
    }
  }
`
